import { Field } from "formik";
import { ErrorMessage } from "../../Form/ErrorMessage/ErrorMessage";
import { FormDescription } from "../../Form/FormDescription/FormDescription";
import { Input } from "../../Form/Input/Input";

export const ContactInfo = () => {
  return (
    <>
      <FormDescription>
        Add contact information about the submitting surgeon. Only name and
        place of education will be shown.
      </FormDescription>
      <Field name="contact.name" as={Input} placeholder="Type your name..." />

      <ErrorMessage name="contact.name" spacing="large" />
      <Field
        name="contact.workplace"
        as={Input}
        placeholder="Type your workplace..."
      />

      <ErrorMessage name="contact.workplace" spacing="large" />
      <Field
        name="contact.education"
        as={Input}
        placeholder="Type your education..."
      />

      <ErrorMessage name="contact.education" spacing="large" />
      <Field
        name="contact.email"
        type="email"
        as={Input}
        placeholder="Type your e-mail..."
      />

      <ErrorMessage name="contact.email" spacing="large" />
    </>
  );
};
